
import { CategoryTabContent } from "./CategoryTabContent";
import { useNewsManagement } from "./useNewsManagement";

// Export the NewsArticle type for backward compatibility
export type { NewsArticle } from "./types";

export default function NewsManagement() {
  const {
    articles,
    newArticle,
    setNewArticle,
    handleAddArticle,
    handleDeleteArticle,
    handleTogglePublic
  } = useNewsManagement();

  return (
    <div className="space-y-6">
      <CategoryTabContent
        title="Διαχείριση Άρθρων"
        articles={articles}
        newArticle={newArticle}
        onChangeArticle={setNewArticle}
        onAddArticle={handleAddArticle}
        onDeleteArticle={handleDeleteArticle}
        onTogglePublic={handleTogglePublic}
      />
    </div>
  );
}
